

export function formatCLABE(title) {
    if (!title) return '';
    let formattedTitle = title.replace(/(CLABE:\s*)([0-9\s]{18,})/gi, (match, prefix, clabeRaw) => {
        const clabe = clabeRaw.replace(/\s+/g, '');
        if (clabe.length === 18) {
            const formatted = `${clabe.slice(0, 3)} ${clabe.slice(3, 6)} ${clabe.slice(6, 17)} ${clabe.slice(17)}`;
            return prefix + formatted;
        }
        return match; 
    });

    if (typeof window !== 'undefined' && window.__pt && window.__pt.settings && window.__pt.settings.site && window.__pt.settings.site.siteName === 'pricetravel') {
        formattedTitle = formattedTitle.replace(/\b(Cuenta|CLABE)\b/gi, '<b class="font-600">$1</b>');
    }

    return formattedTitle;
}

export function getBankName(bankTitle) {
    if (!bankTitle) return 'Banco';
    if (typeof document !== 'undefined') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = bankTitle;
        const strongElement = tempDiv.querySelector('strong');
        return strongElement ? strongElement.textContent : 'Banco';
    }
    const match = bankTitle.match(/<strong>(.*?)<\/strong>/i);
    return match ? match[1] : 'Banco';
}

export function getBankLogo(logoClass) {
    if (!logoClass) return null;
    if (logoClass.includes('//') || logoClass.startsWith('http')) return logoClass;
    const logoMap = {
        'logo-large-banorte': 'https://static.cdnpth.com/assets-core/img/payment/Bank6.svg',
        'logo-large-bbva': 'https://static.cdnpth.com/assets-core/img/payment/Bank8.svg',
        'logo-large-santander': 'https://static.cdnpth.com/assets-core/img/payment/Bank4.svg',
        'logo-large-invex': 'https://static.cdnpth.com/assets-core/img/payment/Bank23.svg',
        'logo-large-hsbc': 'https://static.cdnpth.com/assets-core/img/payment/Bank5.svg',
        'logo-large-banamex': 'https://static.cdnpth.com/assets-core/img/payment/Bank1.svg',
        'logo-large-scotiabank': 'https://static.cdnpth.com/assets-core/img/payment/Bank2.svg',
        'logo-large-inbursa': 'https://static.cdnpth.com/assets-core/img/payment/Bank3.svg',
        'logo-bancolombia': 'https://static.cdnpth.com/assets-core/img/logos_banks/bancolombia-logo.svg',
        'logo-bancodebogota': 'https://static.cdnpth.com/assets-core/img/logos_banks/bancodebogota-logo.svg',
        'logo-davivienda': 'https://static.cdnpth.com/assets-core/img/logos_banks/davivienda-logo.svg',
        'logo-viabaloto': 'https://static.cdnpth.com/assets-core/img/logos_banks/viabaloto-logo.png'
    };
    const classes = logoClass.split(' ');
    const bankClass = classes.find(cls => cls.startsWith('logo-large-') || cls.startsWith('logo-'));
    return bankClass ? logoMap[bankClass] : null;
}

export function getBankAccountInfo(bankTitle) {
    if (!bankTitle) return '';
    return bankTitle.replace(/<strong>.*?<\/strong>\s*<br\s*\/?>/i, '').trim();
}

export function getDepositBanks(data) {
    if (!data || !data.depositInfo || !data.depositInfo.extraInfo) {
        return [];
    }
    try {
        const cleanInfo = data.depositInfo.extraInfo.replace(/[\r\n\t]+/g, ' ');
        const bankInfo = JSON.parse(cleanInfo);
        const banks = bankInfo.BankAccountInformation || [];
        banks.forEach(bank => {
            bank.logoUrl = getBankLogo(bank.Logo);
            
            // Normalize for Colombia where only BankTitle and BankInfo are provided
            if (!bank.BankName && bank.BankTitle) {
                bank.BankName = getBankName(bank.BankTitle);
            }
            if (!bank.BankTitleV2 && bank.BankTitle) {
                bank.BankTitleV2 = getBankAccountInfo(bank.BankTitle);
            }

            if (bank.BankTitleV2) {
                bank.BankTitleV2 = formatCLABE(bank.BankTitleV2);
            }
        });
        return banks;
    } catch (e) {
        console.error('Error parsing depositInfo.extraInfo:', e);
        return [];
    }
}

export function getDepositAccountName(data) {
    if (!data || !data.depositInfo || !data.depositInfo.extraInfo) {
        return '';
    }
    try {
        const cleanInfo = data.depositInfo.extraInfo.replace(/[\r\n\t]+/g, ' ');
        const bankInfo = JSON.parse(cleanInfo);
        return bankInfo.AccountName || '';
    } catch (e) {
        return '';
    }
}

export function getDepositContactEmail(data) {
    if (!data || !data.depositInfo || !data.depositInfo.extraInfo) {
        return '';
    }
    try {
        const cleanInfo = data.depositInfo.extraInfo.replace(/[\r\n\t]+/g, ' ');
        const bankInfo = JSON.parse(cleanInfo);
        return bankInfo.ContactEmail || '';
    } catch (e) {
        return '';
    }
}
